/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Karriere',
    titleMeta: 'Karriere — Ledige stillinger | CamDiab',
    descriptionMeta: 'Udforsk karrieremuligheder hos CamDiab. Bliv en del af holdet, der forbedrer livet med diabetes.',
    keywords: 'CamDiab karriere, job, ledige stillinger, diabetes',
    localeMeta: 'da_dk',

    bannerTitle: 'Ledige stillinger',
    bannerSubtitle: 'Vil du være en del af vores team?',
    heroNote: 'Alle jobopslag offentliggøres på engelsk.',

    introBody:
        'Leder du efter en ny udfordring og vil du være med til at forme meningsfuld forandring? Vi vil gerne høre fra dig. Vi investerer i vores medarbejdere — CamDiabs hjerte. Medarbejderfordele er tilrettelagt for at få det bedste frem i alle, herunder:',

    benefitsTitle: '',
    benefits: [
        'Generøs arbejdsgiverpension',
        'Privat sygeforsikring',
        'Livsforsikring',
        'Årlig diskretionær bonus',
        '29 feriedage plus 8 helligdage',
        'Mulighed for at arbejde med banebrydende teknologi, der kan forandre diabetesbehandling og forbedre patientresultater',
        'Samarbejdende og dynamisk arbejdsmiljø',
        'Konkurrencedygtig løn og ydelser, herunder faglig udvikling og karrieremuligheder',
    ],

    outroHtml:
        'Brænder du for reel virkning i praksis? Vi vil gerne høre fra dig:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Ingen ledige stillinger',
    emptyVacancyBody:
        'Vi ansætter måske ikke lige nu, men CamDiab vokser, og vi vil gerne høre fra mennesker, der brænder for at forbedre livet med diabetes. Kom tilbage senere.',

    applyLabel: 'Ansøg nu',
};
